(function () {
  const observers = new WeakMap();

  const outerWidth = (element) => {
    const style = window.getComputedStyle(element);
    const marginStart = parseFloat(style.marginInlineStart || style.marginLeft) || 0;
    const marginEnd = parseFloat(style.marginInlineEnd || style.marginRight) || 0;
    return element.offsetWidth + marginStart + marginEnd;
  };

  const update = (container) => {
    const swatches = [...container.querySelectorAll('[data-swatch]')];
    const badge = container.querySelector('[data-swatch-badge]');

    if (!badge || swatches.length === 0) return;

    swatches.forEach((swatch) => {
      swatch.hidden = false;
    });
    badge.hidden = true;

    const containerWidth = container.clientWidth;
    if (containerWidth === 0) return;

    const containerStyle = window.getComputedStyle(container);
    const rawGap = containerStyle.columnGap || containerStyle.gap || '0';
    const gap = Number.parseFloat(rawGap) || 0;
    const paddingStart = Number.parseFloat(containerStyle.paddingInlineStart || containerStyle.paddingLeft) || 0;
    const paddingEnd = Number.parseFloat(containerStyle.paddingInlineEnd || containerStyle.paddingRight) || 0;
    const innerWidth = Math.max(0, containerWidth - paddingStart - paddingEnd);

    let totalWidth = 0;
    swatches.forEach((swatch) => {
      totalWidth += outerWidth(swatch);
    });
    if (swatches.length > 1) {
      totalWidth += gap * (swatches.length - 1);
    }

    if (totalWidth <= innerWidth) return;

    badge.hidden = false;
    badge.textContent = '+99';
    const badgeWidth = outerWidth(badge);
    const availableWidth = Math.max(0, innerWidth - badgeWidth - gap);

    let usedWidth = 0;
    let firstHiddenIndex = swatches.length;

    for (let i = 0; i < swatches.length; i++) {
      if (i > 0) usedWidth += gap;
      usedWidth += outerWidth(swatches[i]);
      if (usedWidth > availableWidth) {
        firstHiddenIndex = i;
        break;
      }
    }

    if (firstHiddenIndex < 1) firstHiddenIndex = 1;

    for (let i = firstHiddenIndex; i < swatches.length; i++) {
      swatches[i].hidden = true;
    }

    const hiddenCount = swatches.length - firstHiddenIndex;
    if (hiddenCount > 0) {
      badge.textContent = `+${hiddenCount}`;
    } else {
      badge.hidden = true;
    }
  };

  const attach = (container) => {
    if (!container || observers.has(container)) return;

    const ro = new ResizeObserver(() => update(container));
    ro.observe(container);
    observers.set(container, ro);

    requestAnimationFrame(() => update(container));
    window.setTimeout(() => update(container), 100);
  };

  const initAll = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-swatch-overflow]').forEach(attach);
  };

  const observeDom = () => {
    const mo = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-swatch-overflow]')) attach(node);
          initAll(node);
        });
      });
    });

    mo.observe(document.body, { childList: true, subtree: true });
  };

  const start = () => {
    initAll(document);
    observeDom();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    window.addEventListener('resize', () => initAll(document));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
